import axios from "axios";
import { api } from "./api_route";

export const createSection17OrderRequestsAPI = async (
  section17OrderRequestsData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      section17OrderRequestsData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/sec17OrderRequests/create`,
      section17OrderRequestsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getSection17OrderRequestsByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(
      `${api}/sec17OrderRequests/case/${caseID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateSection17OrderRequestsAPI = async (
  section17OrderRequests_ID,
  section17OrderRequestsData,
) => {
  try {
    const config = {};
    if (
      typeof FormData !== "undefined" &&
      section17OrderRequestsData instanceof FormData
    ) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/sec17OrderRequests/update/${section17OrderRequests_ID}`,
      section17OrderRequestsData,
      config,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteSection17OrderRequestsAPI = async (
  section17OrderRequests_ID,
) => {
  try {
    const response = await axios.delete(
      `${api}/sec17OrderRequests/delete/${section17OrderRequests_ID}`,
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};
